import { ContainerModule, interfaces } from 'inversify';
import { AnnotationReviewStore, IAnnotationReviewStore } from './annotationReview.store';

export const annotationReviewModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IAnnotationReviewStore.$).to(AnnotationReviewStore).inSingletonScope();
});
